@if (mockSafeArea$ | async) {
	<div moveToRoot class="top-0 left-0 w-full h-full fixed pointer-events-none z-max">
		<!-- top area -->
		<div class="top-0 left-0 w-full flex absolute items-center h-safe-t">
			<!-- hour -->
			<div
				class="px-2 flex-none text-xs truncate font-bold flex items-center justify-start w-[5rem]"
			>
				{{ time$ | async }}
			</div>
			<!-- notch -->
			<div class="flex-auto h-full flex items-start justify-center self-start">
				<div class="self-start rounded-0.25 w-1/2 h-0.5 bg-fg-800"></div>
			</div>
			<!-- activity icons -->
			<div class="px-2 flex-none truncate flex items-center justify-end w-[5rem]">
				<i tenantMarkIconClass class="text-s"></i>
			</div>
		</div>
		<!-- bottom area -->
		<div class="bottom-0 left-0 w-full flex absolute items-center justify-center h-safe-b">
			<!-- navigation bar -->
			<div class="rounded-0.25 w-1/2 h-0.5 bg-fg-800"></div>
		</div>
		<!-- left area -->
		<div class="top-0 left-0 h-full absolute w-safe-l"></div>
		<!-- right area -->
		<div class="right-0 h-full absolute w-safe-r"></div>
	</div>
}
